/* eslint-disable react/jsx-no-bind */
/**
 * @file JobSelect 任务选择下拉框
 * @author
 */

import React from 'react';
import {Select} from 'antd';
import SelectSvg from '@assets/icons/select.svg';
import {JobStore} from '@/stores';
import styles from './index.module.less';

interface JobSelectProps {
    jobsList: JobStore[];
    selectedJobId: string;
    onChange: (job: JobStore) => void;
    className?: string;
}

const JobSelect: React.FC<JobSelectProps> = ({jobsList, selectedJobId, onChange, className}) => {
    return (
        <div className={styles.jobSelectWrapper}>
            <Select
                suffixIcon={<SelectSvg />}
                value={selectedJobId}
                popupMatchSelectWidth={183}
                classNames={{popup: {root: 'job-select-dropdown'}}}
                className={`${styles.jobSelect} ${className || ''}`}
                options={jobsList.map((item: JobStore) => ({
                    value: item.job_id,
                    label: item.name,
                    disabled: ['COPYING'].includes(item.status as string),
                    ...item
                }))}
                onChange={(value: string) => {
                    const selectedJob = jobsList.find(job => job.job_id === value);
                    if (selectedJob) {
                        onChange(selectedJob);
                    }
                }}
            />
        </div>
    );
};

export default JobSelect;
